//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import cmFooter from '@/components/cmFooter.vue'

export default {
  name: 'work',
  components: {
      cmFooter
  },
  data () {
    return {
      type:0,
      grade:0,
      count:[],
    }
  },
  created(){
    this.grade = parseInt(this.$func.getLocal('grade'));
  },
  mounted(){
    this.getCurtainOrderCount();

  },
  methods:{
    getCurtainOrderCount(){
      this.$api.getCurtainOrderCount({}).then((res)=>{
        this.count = res.data;
      })
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/curtain.vue